import React from 'react';

// import { Container } from './styles';
interface VimeoProps {
  id: string;
  keyName?: string;
  time?: string;
}

const IframePlayer: React.FC<VimeoProps> = ({ id = '', keyName, time = '0' }) => {

  return (
    <div
      className="video full-width shadow"
      style={{
        position: 'relative',
        paddingBottom: '56.25%' /* 16:9 */,

        height: 0,
        width: '100%',
        overflow: 'hidden',
        borderRadius: '15px'
      }}
    >
      <iframe
        key={keyName}
        frameBorder="0"
        allow="fullscreen"
        allowFullScreen

        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          width: '100%',
          height: '100%',
        }}
        title={id}
        src={id}
      />
    </div>
  );
};

export default IframePlayer;
